const no = Symbol.for("node-only");
export { ProviderError } from "./property-provider/ProviderError";
export { CredentialsProviderError } from "./property-provider/CredentialsProviderError";
export { TokenProviderError } from "./property-provider/TokenProviderError";
export { chain } from "./property-provider/chain";
export { fromValue } from "./property-provider/fromValue";
export { memoize } from "./property-provider/memoize";
export { booleanSelector } from "./util-config-provider/booleanSelector";
export { numberSelector } from "./util-config-provider/numberSelector";
export { SelectorType } from "./util-config-provider/types";
export const getHomeDir = no;
export const ENV_PROFILE = no;
export const DEFAULT_PROFILE = "default";
export const getProfileName = no;
export const getSSOTokenFilepath = no;
export const getSSOTokenFromFile = no;
export const CONFIG_PREFIX_SEPARATOR = no;
export const loadSharedConfigFiles = no;
export const loadSsoSessionData = no;
export const parseKnownFiles = no;
export const externalDataInterceptor = no;
export const readFile = no;
export const loadConfig = no;
export const fromStatic = no;
export const ENV_USE_DUALSTACK_ENDPOINT = no;
export const CONFIG_USE_DUALSTACK_ENDPOINT = no;
export const DEFAULT_USE_DUALSTACK_ENDPOINT = false;
export const NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS = no;
export const nodeDualstackConfigSelectors = no;
export const ENV_USE_FIPS_ENDPOINT = no;
export const CONFIG_USE_FIPS_ENDPOINT = no;
export const DEFAULT_USE_FIPS_ENDPOINT = false;
export const NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS = no;
export const nodeFipsConfigSelectors = no;
export { resolveCustomEndpointsConfig, } from "./config-resolver/endpointsConfig/resolveCustomEndpointsConfig";
export { resolveEndpointsConfig, } from "./config-resolver/endpointsConfig/resolveEndpointsConfig";
export const REGION_ENV_NAME = no;
export const REGION_INI_NAME = no;
export const NODE_REGION_CONFIG_OPTIONS = no;
export const NODE_REGION_CONFIG_FILE_OPTIONS = no;
export { resolveRegionConfig, } from "./config-resolver/regionConfig/resolveRegionConfig";
export { getRegionInfo } from "./config-resolver/regionInfo/getRegionInfo";
export { resolveDefaultsModeConfig, } from "./defaults-mode/resolveDefaultsModeConfig.browser";
